export const RESEND_ACTIVATE_LINK_SUCCESS = 'RESEND_ACTIVATE_LINK_SUCCESS';

export const resendActivateLinkSuccess = () => ({
    type: RESEND_ACTIVATE_LINK_SUCCESS,
});
